'use client';

import React from 'react';

import { Button } from '~/components/ui/button';

interface CollapsibleProps {
  block: React.ReactElement<any, any>;
  collapsedBlock: React.ReactElement<any, any>;
  ctaTitle: string;
}

export function Collapsible({ block, collapsedBlock, ctaTitle }: CollapsibleProps) {
  const [showCollapsed, setShowCollapsed] = React.useState(false);

  const handleClick = React.useCallback<React.MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault();
    setShowCollapsed(true);
  }, []);

  return (
    <>
      {block}
      {!showCollapsed && (
        <div className='text-center'>
          <Button className='bg-white' onClick={handleClick} variant='outline'>
            {ctaTitle}
          </Button>
        </div>
      )}
      {showCollapsed && collapsedBlock}
    </>
  );
}
